import { ScrollTrigger } from "gsap/ScrollTrigger";

/**
 * @typedef {import('swiper').Swiper} Swiper
 */

/**
 * 
 * @param {HTMLElement} swiperContainer
 * @param {Swiper} swiperInstance 
 */
export function attachVisibilityBasedToggler(swiperContainer, swiperInstance) {
    const onEnterHandler = () => {
        // console.log('Re-entering auto-swiper');
        swiperInstance.autoplay.start();
    }
    const onLeaveHandler = () => {
        // console.log('Leaving auto-swiper');
        swiperInstance.autoplay.stop();
    }

    ScrollTrigger.create({
        trigger: swiperContainer,
        start: 'top bottom', // top bottom+=100px
        end: 'bottom top', // bottom+=100px top
        onEnter: onEnterHandler,
        onEnterBack: onEnterHandler,
        onLeave: onLeaveHandler,
        onLeaveBack: onLeaveHandler
    });

    if (!ScrollTrigger.isInViewport(swiperContainer)) {
        onLeaveHandler();
    }
}
